/* OG Sodas — Premium Interactions */
(function () {
  'use strict';

  /* ---- 1. Scroll Reveal via IntersectionObserver ---- */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.og-animate, .og-animate-fade, .og-animate-scale')
        .forEach(function(el) { el.classList.add('og-visible'); });
      return;
    }
    var opts = { threshold: 0.08, rootMargin: '0px 0px -48px 0px' };
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('og-visible');
          observer.unobserve(entry.target);
        }
      });
    }, opts);
    document.querySelectorAll('.og-animate, .og-animate-fade, .og-animate-scale')
      .forEach(function(el) { observer.observe(el); });
  }

  /* ---- 2. FAQ Smooth Accordion ---- */
  function initFAQ() {
    var items = document.querySelectorAll('.og-faq-item');
    items.forEach(function(item) {
      var trigger = item.querySelector('.og-faq-q');
      var answer = item.querySelector('.og-faq-answer');
      if (!trigger || !answer) return;

      // Accessibility
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-expanded', 'false');

      function toggle() {
        var isOpen = item.classList.contains('open');
        // Close all others
        items.forEach(function(other) {
          if (other !== item && other.classList.contains('open')) {
            other.classList.remove('open');
            var otherTrigger = other.querySelector('.og-faq-q');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
      }

      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ---- 3. Floating Mobile CTA ---- */
  function initFloatingCTA() {
    var cta = document.querySelector('.og-floating-cta');
    var heroSection = document.querySelector('.og-hero');
    if (!cta || !heroSection) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          cta.classList.add('og-cta-visible');
        } else {
          cta.classList.remove('og-cta-visible');
        }
      });
    }, { threshold: 0.1 });
    observer.observe(heroSection);
  }

  /* ---- 4. Scroll Indicator Hide on Scroll ---- */
  function initScrollIndicator() {
    var indicator = document.querySelector('.og-scroll-down');
    if (!indicator) return;
    var hidden = false;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 80 && !hidden) {
        indicator.style.opacity = '0';
        indicator.style.pointerEvents = 'none';
        hidden = true;
      } else if (window.scrollY <= 80 && hidden) {
        indicator.style.opacity = '';
        indicator.style.pointerEvents = '';
        hidden = false;
      }
    }, { passive: true });
    indicator.addEventListener('click', function() {
      var next = document.querySelector('.og-values');
      if (next) next.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ---- 5. Product Card Ripple Effect ---- */
  function initProductCards() {
    document.querySelectorAll('.og-prod-card').forEach(function(card) {
      card.addEventListener('mouseenter', function() {
        this.style.willChange = 'transform, box-shadow';
      });
      card.addEventListener('mouseleave', function() {
        this.style.willChange = 'auto';
      });
    });
  }

  /* ---- 6. Smooth Image Loading ---- */
  function initImageFade() {
    document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      img.style.transition = 'opacity 0.4s ease';
      if (!img.complete) {
        img.style.opacity = '0';
        img.addEventListener('load', function() {
          img.style.opacity = '1';
        });
      }
    });
  }

  /* ---- 7. Header scroll shadow ---- */
  function initHeaderScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 16px rgba(2,9,18,0.10)';
      } else {
        header.style.boxShadow = '0 1px 0 rgba(2,9,18,0.07)';
      }
    }, { passive: true });
  }

  /* ---- Init ---- */
  document.addEventListener('DOMContentLoaded', function() {
    initScrollReveal();
    initFAQ();
    initFloatingCTA();
    initScrollIndicator();
    initProductCards();
    initImageFade();
    initHeaderScroll();
  });

})();
